import { AnaColumn } from "../forms-template.service";

export const AccountNoAuth: AnaColumn[] = [
]